module.exports = "/_next/static/images/297065e265626f5747371f10b9510a28-man-looking-at-phone@md-2x.jpg";